import { Link } from "react-router-dom";

import { IUserInfo } from "./types";
import { routes } from "routes";
import { Image } from "components";
import { VerifiedTick } from "components/buttons";
import FALLBACK from "components/icons/user-empty.svg";

import "./UserTile.scss";

interface IUserTileProps {
  user: IUserInfo;
  onFollow: (user: IUserInfo) => void;
}

export const UserTile = (props: IUserTileProps): JSX.Element => {
  return (
    <div className="userTile">
      <div className="main">
        <div className="img-wrap">
          <Link to={routes.user(props.user.id)}>
            <Image className="thumbnail" src={props.user.image} fallback={FALLBACK} />
          </Link>
        </div>

        {props.user.verified && (
          <VerifiedTick
            hint="Verified user"
          />
        )}
      </div>

      <div className="label">
        <Link to={routes.user(props.user.id)}>{props.user.name}</Link>
      </div>
    </div>
  );
};
